<template>
  <div>
    <button
        class="btn"
        :class="classes" :disabled="loading" v-on="$listeners">
      <slot name="spinner">
        <span class="loader h-5 w-5 border-2 rounded-full absolute"
              :class="variants?'border-white':'border-blueGray-700'" v-show="loading"></span>
      </slot>
      <span :class="loading?'invisible':''" class="flex gap-x-2 justify-center items-center">
        <slot name="icon-left">
          <font-awesome-icon :icon="iconLeft" v-if="iconLeft"></font-awesome-icon>
        </slot>
        <slot></slot>
        <slot name="icon-right">
          <font-awesome-icon :icon="iconRight" v-if="iconRight"></font-awesome-icon>
        </slot>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "AppButton",
  props: {
    variants: {
      type: String,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: false
    },
    iconLeft: {
      type: String,
      default: () => null
    },
    iconRight: {
      type: String,
      default: () => null
    },
    ghost: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    colors: {
      primary: 'btn-primary',
      success: 'btn-success',
      warning: 'btn-warning',
      danger: 'btn-danger'
    }
  }),
  computed: {
    classes() {
      return this.colors[this.variants] + (this.ghost ? ' btn-ghost' : '')
    }
  }
}
</script>

<style scoped lang="scss">
.btn {
  @apply px-3 py-2 rounded-md focus:outline-none flex gap-x-2 items-center justify-center font-medium relative text-blueGray-700 bg-gray-100 border-2 box-border;
  &:hover {
    @apply bg-gray-300;
  }

  &:active {
    -webkit-transform: scale(0.99);
    transform: scale(0.99);
  }

  &.btn-primary {
    @apply bg-blue-500 text-white;
    &:hover {
      @apply bg-blue-600;
    }

    &:disabled {
      @apply bg-blue-300;
    }

    &.btn-ghost {
      @apply bg-transparent text-blue-500 border border-blue-500;
      &:hover {
        @apply bg-blue-500 text-white;
      }
    }
  }

  &.btn-success {
    @apply bg-green-500 text-white;
    &:hover {
      @apply bg-green-600;
    }

    &:disabled {
      @apply bg-green-300;
    }

    &.btn-ghost {
      @apply bg-transparent text-green-500 border border-green-500;
      &:hover {
        @apply bg-green-500 text-white;
      }
    }
  }

  &.btn-warning {
    @apply bg-amber-500 text-white;

    &:hover {
      @apply bg-amber-600;
    }

    &:disabled{
      @apply bg-red-300;
    }

    &.btn-ghost {
      @apply bg-transparent text-amber-500 border border-amber-500;
      &:hover {
        @apply bg-amber-500 text-white;
      }
    }
  }

  &.btn-danger {
    @apply bg-red-500 text-white;

    &:hover {
      @apply bg-red-600;
    }

    &.btn-ghost {
      @apply bg-transparent text-red-500 border-2 border-red-500;
      &:hover {
        @apply bg-red-500 text-white;
      }
    }
  }

}

@keyframes loader-rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loader {
  border-right-color: transparent;
  animation: loader-rotate 1s linear infinite;
}
</style>